import React from 'react';
import styled from 'styled-components';
import { LinkButton } from '../../CommonComponents/Button';
import { WorkflowWrapper as WorkflowWrapperBase } from '../../Workflow/Workflow.styles';

export const Container = styled.div`
  min-width: 580px;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    flex-direction: row;
  }

  * {
    box-sizing: border-box;
  }
`;

export const Models = styled.div`
  width: 100%;
`;

export const LeftWrapper = styled.div`
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    width: 50%;
  }
`;

export const LabelText = styled.span`
  display: inline-block;
  color: #444;
  margin-bottom: 16px;
  font-weight: 600;
`;

export const Portfolios = styled.div`
  width: 100%;
  margin-right: 24px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;

  button {
    border-bottom: 1px solid #ccc;
    display: block;
    &:last-child {
      border: none;
    }
    .text {
      width: 440px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      line-height: 30px;
    }
  }
`;

export const ChartArea = styled.div<{ isEmpty: boolean }>`
  flex: 1;
  margin-top: 24px;
  margin-left: 0;
  padding: 0 24px 0 0;
  background: #fff;
  max-width: 600px;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    margin-top: 0;
    margin-left: 24px;
    padding: 0 24px;
  }
`;

export const WorkflowWrapper = styled(WorkflowWrapperBase)({
  [Wrapper]: {
    flexDirection: 'column',
  },

  [LeftWrapper]: {
    width: '100%',
    flexShrink: 0,
  },

  [ChartArea]: {
    marginTop: 24,
    marginLeft: 0,
    padding: '0 24px 0 0',
  },
});

export const Detail = styled.div`
  color: #444;
  font-weight: 400;
`;

export const Disclosure = styled.div`
  margin-top: 20px;
  color: #e75953;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 48px;

  > * {
    margin-right: 24px;
  }
`;

export const ChartSection = styled.div<{ sameLine?: boolean }>`
  display: flex;
  flex-direction: ${({ sameLine }) => (sameLine ? 'row' : 'column')};
  align-items: ${({ sameLine }) => (sameLine ? 'center' : 'flex-start')};
  padding: 12px 0;

  ${LabelText} {
    margin: ${({ sameLine }) => (sameLine ? '0 16px 0 0' : '0 16px 6px 0')};
  }

  ${Detail} {
    margin: ${({ sameLine }) => (sameLine ? '0' : '0 24px 6px 0')};
    width: ${({ sameLine }) => (sameLine ? 'auto' : '100%')};
  }

  &:first-child {
    padding-top: 0;
  }
`;

export const ChartContainer = styled.div`
  height: 200px;
  padding: 24px 0;
  width: 400px;
`;

export const StyledLinkButton = styled(LinkButton)`
  color: #0078d4;
  font-weight: 600;
`;

export const RiskBand = styled.div`
  padding: 8px;
  font-size: 14px;
  border-radius: 20px;
  font-weight: 600;
  margin-right: 16px;
  min-width: 64px;
  text-align: center;
  line-height: 1em;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PortfolioItem = styled(({ isSelected, ...other }) => <LinkButton {...other} />)`
  > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  box-sizing: border-box;
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#444')};
  background: ${({ isSelected }) => (isSelected ? '#0078D4' : '#fff')};
  width: 100%;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 0;

  && {
    &:hover {
      background: ${({ isSelected }) => (isSelected ? '#0087E2' : '#f6f6f6')};
    }

    &:focus {
      background: ${({ isSelected }) => (isSelected ? '#0087E2' : '#fff')};
    }
  }

  ${RiskBand} {
    color: ${({ isSelected }) => (isSelected ? '#0078D4' : '#fff')};
    background: ${({ isSelected }) => (isSelected ? '#fff' : '#0078D4')};
  }
`;

export const RiskScore = styled.span`
  font-weight: 600;
  font-size: 32px;
  vertical-align: sub;
  margin-left: 8px;
`;

export const RiskinessImage = styled.img`
  width: 32px;
  margin-right: 16px;
`;
